module.exports = __webpack_public_path__ + "img/page_info_nocomment.630c6ad.svg";